// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2aiyJ","label":"CategoryService_label__spobt","location":"CategoryService_location__-wlVn"};